import * as atypes from "src/constants/actionTypes";

export const changeLanguage = language => ({
  type: atypes.CHANGE_LANGUAGE,
  payload: language
});
